import "assets/scss/layouts/provider.scss";

import React from "react";
import { useApp } from "context";
import { Common } from "components";
import { Outlet } from "react-router-dom";

export const ProviderLayout = () => {
  const { theme } = useApp();

  return (
    <div
      className="qh-provider"
      style={{
        color: theme.palette.font.color,
        backgroundColor: theme.palette.background.color,
      }}
    >
      <div className="qh-container">
        <Common.Navigation />
        <div className="qh-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
